module.exports = {
      id: "gallery-whitebg-usage",
      viewBox: "0 0 90 90",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#gallery-whitebg",
      toString: function () {
        return this.url;
      }
    }